import { render } from "./message-desc.vue?vue&type=template&id=6f44c7e8"
import script from "./message-desc.vue?vue&type=script&lang=js"
export * from "./message-desc.vue?vue&type=script&lang=js"

import "./message-desc.vue?vue&type=style&index=0&id=6f44c7e8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__